import * as z from 'zod';
import { CheckoutStatusSchema } from '../enums/CheckoutStatus.schema';
import { CurrencySchema } from '../enums/Currency.schema';

export const CheckoutSchema = z.object({
  id: z.string(),
  sessionId: z.string(),
  status: CheckoutStatusSchema.default("DRAFT"),
  currency: CurrencySchema.default("gbp"),
  totalCents: z.number().int(),
  totalDepositCents: z.number().int().nullish(),
  stripeSetupIntentId: z.string().nullish(),
  stripePaymentMethodId: z.string().nullish(),
  stripeCustomerId: z.string().nullish(),
  stripeCheckoutSessionUrl: z.string().nullish(),
  bookingEmailAddress: z.string().nullish(),
  marketingConsent: z.boolean().nullish(),
  bookingReference: z.string().nullish(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  submittedAt: z.coerce.date().nullish(),
  userId: z.string().nullish(),
});

export type CheckoutType = z.infer<typeof CheckoutSchema>;
